import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CartService } from '../../../shared/services/cart.service';
import { map } from 'rxjs/operators';
import { ShopService } from 'src/app/shared/api/shop.service';
import { StoreService } from 'src/app/shared/services/store.service';
import { GiacenzaControlService } from 'src/app/shared/services/giacenza-control.service';

@Injectable({
    providedIn: 'root'
})
export class CheckoutGuard implements CanActivate  {
    constructor(
        private cart: CartService,
        private router: Router,
        private shop : ShopService,
        private store : StoreService,
        private giacenzaControl : GiacenzaControlService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.shop.getShopInfo().pipe(map(shopInfo => {
            for (let item of this.cart.items)
                if (this.giacenzaControl.hasQuantityError(item, 'cart', item.quantity, item.quantity)) {
                    this.router.navigateByUrl('/shop/cart').then();
                    return false;
                }
                    
            if (!this.cart.shippingMethod) {
                this.router.navigateByUrl('/shop/cart').then();
                return false;
            }
            if (this.cart.shippingMethod.condizione_articoli && this.cart.principi_articolo) {
                for (let item of this.cart.items) {
                    let articolo = item.product;
                    let includedByCodArt = this.cart.principi_articolo.find(principio => principio.flag_escluso_incluso && principio.codice_articolo == articolo.codart);
                    if (includedByCodArt) {
                        if (includedByCodArt.limite_max && (includedByCodArt.limite_max < item.quantity)) {
                            this.router.navigateByUrl('/shop/cart').then();
                            return false;
                        }
        
                        if (includedByCodArt.limite_min && (includedByCodArt.limite_min > item.quantity)) {
                            this.router.navigateByUrl('/shop/cart').then();
                            return false;
                        }
                    }
                }
            }

            let impostazioni_consegna = shopInfo['impostazioni_consegna'];
    
            if (this.cart.items.length) {
                if (this.cart.destination && this.cart.shippingMethod) {
                    if (impostazioni_consegna['attivo'] && impostazioni_consegna['flg_fascia'] && 
                    ((this.store.price == 'b2b' && this.cart.shippingMethod?.tipo_spedizione != 1)  || (this.store.price == 'b2c' && this.cart.shippingMethod?.tipo_spedizione == 2))) {
                        if (impostazioni_consegna['flg_obb_data']) {
                            if (this.cart.deliveryDate) {
                                if (impostazioni_consegna['flg_obb_fascia']) {
                                    if (this.cart.deliveryTime) {
                                        return true;
                                    }
                                }
                                else {
                                    return true;
                                }
                            }
                        }
                        else {
                            return true;
                        }
                    }
                    else {
                        return true;
                    }
                }
            }

            this.router.navigateByUrl('/shop/cart').then();

            return false;
        }));
    }
}
